export const environment = {
  production: true,
  env: "#{ENVIRONMENT}#",
  firebase: {
    apiKey: '#{SCIO_NAV_FIREBASE_API_KEY}#',
    authDomain: '#{SCIO_NAV_FIREBASE_AUTH_DOMAIN}#',
    projectId: '#{SCIO_NAV_FIREBASE_PROJECT_ID}#',
    storageBucket: '#{SCIO_NAV_FIREBASE_STORAGE_BUCKET}#',
    messagingSenderId: '#{SCIO_NAV_FIREBASE_MESSAGING_SENDER_ID}#',
    appId: '#{SCIO_NAV_FIREBASE_APP_ID}#',
    measurementId: '',
    databaseURL: ''
  },
  OIDC_PROVIDER: "#{OIDC_PROVIDER}#",
  globalHostName: "#{GLB_HOSTNAME}#",
  firebaseAppJunction:"#{firebaseAppJunction}#",
  // FIREBASE LOG CONFIGS
  FIREBASE_LOG_COLLECTION: '#{FIREBASE_LOG_COLLECTION}#', // The default name of the log collection
  FIREBASE_LOG_RETENTION_AGE: '#{FIREBASE_LOG_RETENTION_AGE}#', // The default TTL for the log entry (in days)
  FIREBASE_LOG_ENABLED: '#{FIREBASE_LOG_ENABLED}#' // Log enabled flag
};